var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"view-in-room__room js-view-in-room-room\"><img class=\"view-in-room__placeholder js-view-in-room-placeholder\"></div><img class=\"view-in-room__artwork js-view-in-room-artwork\"><a class=\"view-in-room__close js-view-in-room-close\"><i class=\"icon-close\"></i></a><div class=\"view-in-room__measurement-flex-container\"><div class=\"view-in-room__measurement js-view-in-room-measurement\"> <div class=\"view-in-room__measurement-feet\">8 ft.</div><div class=\"view-in-room__measurement-bar js-view-in-room-measurement-bar\"> <div class=\"view-in-room__measurement-line\"></div></div></div></div>");;return buf.join("");
};
module.exports = template;